import React, { useState } from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
import { IoMdArrowDropdown } from "react-icons/io"

const NavBlog = () => {
  const data = useStaticQuery(graphql`
    {
      allStrapiBlogs {
        distinct(field: category)
      }
    }
  `)

  const {
    allStrapiBlogs: { distinct },
  } = data

  const [toggle, setToggle] = useState(false)

  return (
    <div className="blog-nav">
      <div className="container">
        <ul className="d-lg-flex d-none">
          <li>
            <Link activeClassName="style-links" to="/blog">
              Blog Home
            </Link>
          </li>
          {distinct?.map((item, i) => {
            return (
              <li key={i}>
                <Link to={`/blog/${item}`} activeClassName="style-links">
                  {item}
                </Link>
              </li>
            )
          })}
        </ul>
        <div className="d-lg-none">
          <div className="my-dropdown p-3 d-flex align-items-center">
            <p>Blog home</p>
            <IoMdArrowDropdown
              onClick={() => setToggle(!toggle)}
              className="t-icon"
            />
          </div>
          {toggle && (
            <div className="my-dropdown-items">
              <li>
                <Link to="/blog" activeClassName="style-links">
                  Blog home
                </Link>
              </li>
              {distinct.map((item, i) => {
                return (
                  <li key={i}>
                    <Link to={`/blog/${item}`} activeClassName="style-links">
                      {item}
                    </Link>
                  </li>
                )
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default NavBlog
